import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import disableReactDevTools from "./disableDevTools";
import App from "./App";
import "./index.scss";

disableReactDevTools();

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
